var _defs, _tspan, _tspan2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 340,
    viewBox: "680 0 550 340",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 503,
    width: 1168.0573,
    height: 235.22546,
    id: "rect29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 503,
    width: 1168.0573,
    height: 235.22546,
    id: "rect29-48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(12,-344.7753)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text29",
    style: {
      fontSize: "184.773px",
      lineHeight: 1.4,
      textAlign: "start",
      letterSpacing: 25,
      wordSpacing: "0.78px",
      writingMode: "lr-tb",
      direction: "ltr",
      whiteSpace: "pre",
      shapeInside: "url(#rect29)",
      display: "inline",
      fill: "#000000"
    },
    x: 1985.6023,
    y: 0,
    transform: "matrix(1.0391104,0,0,1.0391104,247.04839,-206.82483)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 880.66,
    y: 686.68163,
    id: "tspan5"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: 600,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Semi-Bold'",
      textAlign: "center",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "tspan1"
  }, "ANTERRO"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text29-2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 60,
      lineHeight: 1.4,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "Montserrat",
      textAlign: "start",
      letterSpacing: 25,
      wordSpacing: "0.78px",
      writingMode: "lr-tb",
      direction: "ltr",
      whiteSpace: "pre",
      shapeInside: "url(#rect29-48)",
      display: "inline",
      fill: "#000000"
    },
    x: 1985.6023,
    y: 0,
    transform: "matrix(1.039,0,0,1.0391104,306.19932,21.339909)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 548.92056,
    id: "tspan7"
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: "0 0 0 0 0 0 0 0 0 0 -0.7799809",
    id: "tspan6"
  }, "CONNECTING\n"))), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 613.59134,
    id: "tspan9"
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.77999878",
    id: "tspan8"
  }, "            TOMORROW"))))), /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "translate(12,-368.55264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect6",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.395652
    },
    d: "m 289.08627,370.3937 h 87.04368 L 569.46328,706.77165 H 482.4196 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6-7",
    style: {
      fill: "#00aa88",
      fillOpacity: 1,
      strokeWidth: 0.395652
    },
    d: "m 220.60605,570.70866 h 85.83156 l -78.78786,136.06299 h -87.64976 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTxt);
export default __webpack_public_path__ + "static/media/logo-txt.e4f1089e2757621706923617c32ed2df.svg";
export { ForwardRef as ReactComponent };